<template>
  <div id="app">
     <editor id="editor_id" height="500px" width="700px" :content.sync="editorText"
            :afterChange="afterChange()"
            :loadStyleMode="false"
            @on-content-change="onContentChange"></editor>
    <div> editorTextCopy: {{ editorTextCopy }} </div>
 
  </div>
</template>
 
<script>
import editor from '../components/kindeditor.vue'
 
export default {
  name: 'app',
  components: {
    editor
  },
  data () {
    return {
      editorText: '直接初始化值', // 双向同步的变量
      editorTextCopy: ''  // content-change 事件回掉改变的对象
    }
  },
    methods: {
    onContentChange (val) {
      this.editorTextCopy = val;
      window.console.log(this.editorTextCopy)
    },
    afterChange () {

    },
    afterUpload() {
      console.log(999)
    },
    uploadJson() {
      console.log(666)
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/views/video.vue